import React, { useEffect, useState } from "react";
import { BASE_URL_PREBID } from "../../config/axios";
import axios from "axios";

import { formatRoundoff } from "../custom";
import { useNavigate } from "react-router-dom";

const PendingInvoice = () => {

    const [invoicedata, setInvoicedata] = useState([]);

    useEffect(() => {
        const getpendinginvoicedata = async () => {
            try {
                const res = await axios.get(`${BASE_URL_PREBID}/project/projectspendingsforbilling/`);
                setInvoicedata(res.data);

            } catch (err) {
                // alert(err.message);
            }
        };
        getpendinginvoicedata();
    }, []);

    const navigate = useNavigate()


    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    const baseUrl = "/" + urlParts[3] + `/invoicebyproject`;
    const InvoicePage = (pr_code) => {
        navigate(baseUrl + `/${pr_code}/`)
    }
    return (
        <div className="invoice-cont height50vh    cont-col cards-shadow2 bgwhite" style={{ padding: "10px 0" }}>
            <div className="justify-between cont-row align-cen bgwhite mary-10 mary10">
                <div>
                    <h1 className="repo-heading font-size-heading font-weight500card-heading font-sizeheading" style={{ paddingLeft: "20px", marginBottom: "0" }}>Pending Invoice</h1>
                </div>
            </div>

            <div className="global-table-cont scroll-container-table " style={{ minHeight: "45vh" }}>
                <table className="custom-table" >
                    <thead>
                        <tr className="custom-table-head-trr-new global-table-tr">
                            <th className="align-center font-size-text font-weight400" style={{ width: "2vw" }}>Sr no.</th>
                            <th className="align-center font-size-text font-weight400" style={{ width: "6vw" }}>Project Code</th>
                            <th className="align-left font-size-text font-weight400" style={{ width: "10vw" }}>Project Name</th>
                            <th className="align-left font-size-text font-weight400" style={{ width: "14vw" }}>Client Name</th>
                            <th className="align-left font-size-text font-weight400">Stage Name</th>
                            <th className="align-center font-size-text font-weight400">Billing Percentage</th>
                            <th className="align-right font-size-text font-weight400">Billing Amount</th>
                            <th className="align-right font-size-text font-weight400">WO Amount with GST</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoicedata.map((items, index) => {



                            return (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="8"></td>
                                    </tr>
                                    <tr title="Navigate to Invoice Page" style={{ cursor: "pointer" }} className="custom-table-head-td global-table-td">
                                        <td className="align-center font-size-text font-weight400">{index + 1}</td>
                                        <td className="align-center font-size-text font-weight400">{items.prebid_prcode}</td>
                                        <td className="align-left font-size-text font-weight400">{items.project_short_name}</td>
                                        <td className="align-left font-size-text font-weight400">{items.client_name}</td>
                                        <td className="align-left font-size-text font-weight400">{items.data.workStages}</td>
                                        <td className="align-center font-size-text font-weight400">{items.data.percentage}%</td>
                                        <td className="align-right font-size-text font-weight400">{formatRoundoff((items.woamount_name * items.data.percentage) / 100)}</td>
                                        <td className="align-right font-size-text font-weight400">{formatRoundoff(items.woamount_name)}</td>
                                    </tr>
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div >
    )
}

export default PendingInvoice